// 轮播图管理
export default [
  {
    path: "/carouselManage",
    name: "carouselManage",
    meta: { title: "轮播图管理" },
    component: () => import("../views/carouselManage/index"),
    children: [
      {
        path: "/carouselManage/serviceMall",
        meta: { title: "服务商城轮播图", isMenu: true },
        component: () => import("../views/carouselManage/serviceMall"),
      },
      {
        path: "/carouselManage/onlineMall",
        meta: { title: "购物商城轮播图" },
        component: () => import("../views/carouselManage/onlineMall"),
      },
    ],
  },
]